import { useTranslation } from 'next-i18next';
import * as React from 'react';
import { ReactElement } from 'react';

import { handleDownload } from '@/modules/packhouse/printingOrders/components/GeneralPrintingOrders/PrintingOrderRow/OrdersList/OrderCardContent/Printing/logic';
import { IPrintingOrders } from '@/modules/packhouse/printingOrders/types';
import { Button } from '@/shared/components/atoms';
import { BaseIcon } from '@/shared/components/atoms/IconButton/BaseIcon';

import ExcelIcon from '~/images/shared/note.svg';

interface IProps {
  patchQRCodesData: IPrintingOrders.IGeneratedWorkerQRCodesDataItem[];
}
export default function ExportExcel({
  patchQRCodesData,
}: IProps): ReactElement {
  const { t } = useTranslation('common');

  return (
    <Button
      color='primary'
      variant='text'
      className='flex  items-center justify-center gap-8'
      disabled={patchQRCodesData?.length === 0}
      onClick={() => handleDownload(patchQRCodesData)}
    >
      <>
        <BaseIcon size='sm'>
          <ExcelIcon />
        </BaseIcon>
        {t('download-xlsx')}
      </>
    </Button>
  );
}
